import React from 'react';

const SvgInternationalEnvironment = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 104 104"
}, props), /*#__PURE__*/React.createElement("g", {
  className: "tourlane-Careers-InternationalEnvironment__nc-icon-wrapper"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "tourlane-Careers-InternationalEnvironment__path-1",
  d: "M16.537 0S9.74 1.717 4.541 10.165C-.657 18.612.03 24.67.03 24.67H0h58.21s.687-6.058-4.511-14.505C49.403 3.184 44.015.255 42.273.045"
}), /*#__PURE__*/React.createElement("path", {
  id: "tourlane-Careers-InternationalEnvironment__path-5",
  d: "M36.502 29.087c0 13.756-9.538 25.284-22.36 28.332l-.002-.203-.008-.266-.023-.452-.025-.338-.034-.365-.045-.392-.057-.418a21.43 21.43 0 00-.033-.22l-.076-.456-.09-.481-.107-.505-.123-.53-.142-.55c-.05-.188-.104-.38-.16-.574l-.182-.595a29.687 29.687 0 00-.812-2.241l-.288-.683a35.617 35.617 0 00-2.334-4.448 42.593 42.593 0 00-1.92-2.862l-.475-.634a32.763 32.763 0 00-2.079-2.464l-.444-.464a24.16 24.16 0 00-.65-.64l-.422-.392a20.862 20.862 0 00-.613-.533l-.394-.32c-.13-.102-.257-.2-.382-.293l-.369-.266-.354-.24-.34-.212c-.516-.552-.7-.755-1.159-.845 4.683-4.263 7.963-11.187 7.963-18.89 0-1.631-.085-2.34-.367-3.88l.038.013a1.04 1.04 0 001.369-.987L8.942.522c0-.188-.05-.367-.14-.522 15.422.741 27.7 13.48 27.7 29.087z"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "tourlane-Careers-InternationalEnvironment__path-3",
  cx: 23.981,
  cy: 24.041,
  rx: 23.981,
  ry: 24.041
})), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(10 65.055)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "tourlane-Careers-InternationalEnvironment__mask-2",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#tourlane-Careers-InternationalEnvironment__path-1"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#59DD7D",
  xlinkHref: "#tourlane-Careers-InternationalEnvironment__path-1"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#50C871",
  d: "M34.32 10.4h10.4v6.552l-5.2 2.808-5.2-2.808z",
  mask: "url(#tourlane-Careers-InternationalEnvironment__mask-2)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F5F5F5",
  d: "M22.326 10.438c.511 0 .926.415.926.927v.473a.927.927 0 01-.926.926h-1.337v4.888a.927.927 0 01-.926.927h-.409a.927.927 0 01-.926-.927v-4.889l-1.336.001a.927.927 0 01-.927-.926v-.473c0-.512.415-.927.927-.927h4.934z",
  mask: "url(#tourlane-Careers-InternationalEnvironment__mask-2)"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#ECECEC",
  transform: "translate(15.139 22.125)",
  xlinkHref: "#tourlane-Careers-InternationalEnvironment__path-3"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M62.192 33.83C59.415 22.976 50.138 15 39.12 15c-11.2 0-20.601 8.242-23.204 19.37-.468 1.998 46.829 1.62 46.276-.54z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BDBDBD",
  d: "M15.813 31.086c7.44-2.507 15.21-3.76 23.307-3.76 8.097 0 15.866 1.253 23.307 3.76a1 1 0 01.676.85l.829 8.439a1 1 0 01-1.29 1.053c-7.613-2.342-15.366-3.514-23.257-3.514-7.915 0-15.848 1.179-23.8 3.536a1 1 0 01-1.278-1.057l.83-8.457a1 1 0 01.676-.85z"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#8D8D8D"
}, /*#__PURE__*/React.createElement("path", {
  d: "M45.508 56.544c.612-.36 1.4-.154 1.758.46a1.29 1.29 0 01-.458 1.762c-2.133 1.253-4.576 1.877-7.307 1.877-2.72 0-5.233-.618-7.52-1.855a1.29 1.29 0 01-.522-1.744 1.283 1.283 0 011.74-.523c1.908 1.03 4.002 1.546 6.302 1.546 2.287 0 4.282-.51 6.007-1.523zM32.717 48.103a1.026 1.026 0 001.452-.046 1.032 1.032 0 00-.046-1.457c-1.406-1.321-3.057-1.996-4.906-1.996-1.837 0-3.527.665-5.033 1.967a1.032 1.032 0 00-.108 1.454c.371.43 1.021.479 1.451.107 1.142-.988 2.36-1.467 3.691-1.467 1.32 0 2.47.47 3.5 1.438zM53.272 48.103a1.026 1.026 0 001.452-.046 1.032 1.032 0 00-.046-1.457c-1.405-1.321-3.056-1.996-4.906-1.996-1.837 0-3.527.665-5.033 1.967a1.032 1.032 0 00-.107 1.454c.37.43 1.02.479 1.45.107 1.142-.988 2.36-1.467 3.69-1.467 1.32 0 2.47.47 3.5 1.438z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(57.738 31.518)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "tourlane-Careers-InternationalEnvironment__mask-6",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#tourlane-Careers-InternationalEnvironment__path-5"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#ECECEC",
  xlinkHref: "#tourlane-Careers-InternationalEnvironment__path-5"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#59DD7D",
  d: "M14.141 59.991l-2.585-9.265.866-6.5 7.259-1.45.687 3.433a.74.74 0 00.492.559l4.413.723c.25.082 1.687-1.447 1.886-1.619l6.046-8.931 11.046-3.404c-5.083 7.838-16.64 24.192-26.536 24.192-2.403 0-1.343 2.828-3.574 2.262z",
  mask: "url(#tourlane-Careers-InternationalEnvironment__mask-6)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#59DD7D",
  d: "M34.825 5.089l-6.428 2.753a.922.922 0 00-.554.93l.999 10.99-4.327 5.192-6.526-5.594a.92.92 0 00-.78-.205l-4.859.973-1.579-.768C15.1 7.842 23.43 2.382 33.074.413l1.75 4.676z",
  mask: "url(#tourlane-Careers-InternationalEnvironment__mask-6)",
  transform: "matrix(-1 0 0 1 45.596 0)"
})))));

export default SvgInternationalEnvironment;